import { msg } from '@lingui/core/macro';
import type { FieldMetadataMessageDescriptorDef } from './types';

export const fuelKindField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Fuel kind',
    context: 'The kind of fuel used.',
  }),
  externalDescription: msg({
    message: 'The type of fuel used in combustion activities.',
  }),
};

export const fuelCombustionReasonField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Fuel combustion reason',
    context: 'The reason for the fuel combustion.',
  }),
  externalDescription: msg({
    message: 'The reason for the fuel combustion.',
    context: 'Fuel combustion reason',
  }),
};

export const fuelConsumptionUnitField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Fuel consumption unit',
    context:
      'Unit (e.g. liters) for a column of data describing an amount of fuel consumption',
  }),
  externalDescription: msg({
    message:
      'The unit of lifetime fuel consumption and fuel consumption at time of sale.',
    context:
      'Description for a unit (e.g. liters) of a column of data describing an amount of fuel consumption',
  }),
};

export const lifetimeFuelConsumptionField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Lifetime fuel consumption',
    context: 'The fuel consumption over the lifetime of a sold product.',
  }),
};

export const fuelConsumptionQuantityField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Fuel consumption',
    context: 'The display name for a metric',
  }),
};

export const rawFuelUnitField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Raw fuel unit',
    context: 'The display name for a dimension',
  }),
};
